import { proxy } from "valtio";
import { FuiUserAvatar } from "~/pages/heineken_template/components/FuiUserAvatar";


export const eurex_store = proxy({ userAvatar: new FuiUserAvatar() })